// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FilterBar_wrapper__XWLrX","container":"FilterBar_container__B5PQI","filter":"FilterBar_filter__u_XKm","active":"FilterBar_active__jXN96","icon":"FilterBar_icon__2CQiz"};